/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  DepartmentApiResource,
  DepartmentRequest,
  GetApiDepartmentList200,
  GetApiDepartmentListParams,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiDepartmentListResponse200 = {
  data: GetApiDepartmentList200
  status: 200
}

export type getApiDepartmentListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiDepartmentListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiDepartmentListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiDepartmentListResponseSuccess = (getApiDepartmentListResponse200) & {
  headers: Headers;
};
export type getApiDepartmentListResponseError = (getApiDepartmentListResponse400 | getApiDepartmentListResponse401 | getApiDepartmentListResponse403) & {
  headers: Headers;
};

export type getApiDepartmentListResponse = (getApiDepartmentListResponseSuccess | getApiDepartmentListResponseError)

export const getGetApiDepartmentListUrl = (params?: GetApiDepartmentListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/departments?${stringifiedParams}` : `/api/departments`
}

export const getApiDepartmentList = async (params?: GetApiDepartmentListParams, options?: RequestInit): Promise<getApiDepartmentListResponse> => {
  
  return customFetch<getApiDepartmentListResponse>(getGetApiDepartmentListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiDepartmentCreateResponse201 = {
  data: DepartmentApiResource
  status: 201
}

export type postApiDepartmentCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiDepartmentCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiDepartmentCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiDepartmentCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiDepartmentCreateResponseSuccess = (postApiDepartmentCreateResponse201) & {
  headers: Headers;
};
export type postApiDepartmentCreateResponseError = (postApiDepartmentCreateResponse400 | postApiDepartmentCreateResponse401 | postApiDepartmentCreateResponse403 | postApiDepartmentCreateResponse409) & {
  headers: Headers;
};

export type postApiDepartmentCreateResponse = (postApiDepartmentCreateResponseSuccess | postApiDepartmentCreateResponseError)

export const getPostApiDepartmentCreateUrl = () => {


  

  return `/api/departments`
}

export const postApiDepartmentCreate = async (departmentRequest: DepartmentRequest, options?: RequestInit): Promise<postApiDepartmentCreateResponse> => {
  
  return customFetch<postApiDepartmentCreateResponse>(getPostApiDepartmentCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      departmentRequest,)
  }
);}


export type getApiDepartmentGetResponse200 = {
  data: DepartmentApiResource
  status: 200
}

export type getApiDepartmentGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiDepartmentGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiDepartmentGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiDepartmentGetResponseSuccess = (getApiDepartmentGetResponse200) & {
  headers: Headers;
};
export type getApiDepartmentGetResponseError = (getApiDepartmentGetResponse401 | getApiDepartmentGetResponse403 | getApiDepartmentGetResponse404) & {
  headers: Headers;
};

export type getApiDepartmentGetResponse = (getApiDepartmentGetResponseSuccess | getApiDepartmentGetResponseError)

export const getGetApiDepartmentGetUrl = (id: number,) => {


  

  return `/api/departments/${id}`
}

export const getApiDepartmentGet = async (id: number, options?: RequestInit): Promise<getApiDepartmentGetResponse> => {
  
  return customFetch<getApiDepartmentGetResponse>(getGetApiDepartmentGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiDepartmentUpdateResponse200 = {
  data: DepartmentApiResource
  status: 200
}

export type putApiDepartmentUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiDepartmentUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiDepartmentUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiDepartmentUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}

export type putApiDepartmentUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiDepartmentUpdateResponseSuccess = (putApiDepartmentUpdateResponse200) & {
  headers: Headers;
};
export type putApiDepartmentUpdateResponseError = (putApiDepartmentUpdateResponse400 | putApiDepartmentUpdateResponse401 | putApiDepartmentUpdateResponse403 | putApiDepartmentUpdateResponse404 | putApiDepartmentUpdateResponse409) & {
  headers: Headers;
};

export type putApiDepartmentUpdateResponse = (putApiDepartmentUpdateResponseSuccess | putApiDepartmentUpdateResponseError)

export const getPutApiDepartmentUpdateUrl = (id: number,) => {


  

  return `/api/departments/${id}`
}

export const putApiDepartmentUpdate = async (id: number,
    departmentRequest: DepartmentRequest, options?: RequestInit): Promise<putApiDepartmentUpdateResponse> => {
  
  return customFetch<putApiDepartmentUpdateResponse>(getPutApiDepartmentUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      departmentRequest,)
  }
);}


export type deleteApiDepartmentDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiDepartmentDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiDepartmentDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiDepartmentDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiDepartmentDeleteResponseSuccess = (deleteApiDepartmentDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiDepartmentDeleteResponseError = (deleteApiDepartmentDeleteResponse401 | deleteApiDepartmentDeleteResponse403 | deleteApiDepartmentDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiDepartmentDeleteResponse = (deleteApiDepartmentDeleteResponseSuccess | deleteApiDepartmentDeleteResponseError)

export const getDeleteApiDepartmentDeleteUrl = (id: number,) => {


  

  return `/api/departments/${id}`
}

export const deleteApiDepartmentDelete = async (id: number, options?: RequestInit): Promise<deleteApiDepartmentDeleteResponse> => {
  
  return customFetch<deleteApiDepartmentDeleteResponse>(getDeleteApiDepartmentDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


